import strapi, { mapStrapiData } from '../lib/strapi';
import qs from 'qs';

export const getFarmerPageData = async () => {
  try {
    const query = qs.stringify({
      populate: {
        hero_image: true,
        features_list: { populate: '*' },
        app_images: true,
        play_store_url: true,
        app_store_image: true
      }
    });

    const response = await strapi.get(`/for-farmers-page?${query}`);
    return mapStrapiData(response);
  } catch (error) {
    console.error('Error fetching For Farmers Page data:', error);
    return null;
  }
};